import {
  LOAD_API_CLIENTS_REQUEST, LOAD_API_CLIENTS_SUCCESS, LOAD_API_CLIENTS_FAIL,
  LOAD_RESTRICTED_CLIENTS_REQUEST, LOAD_RESTRICTED_CLIENTS_SUCCESS, LOAD_RESTRICTED_CLIENTS_FAIL,
  POST_API_CLIENTS_REQUEST, POST_API_CLIENTS_SUCCESS, POST_API_CLIENTS_FAIL,
  DELETE_API_CLIENTS_REQUEST, DELETE_API_CLIENTS_SUCCESS, DELETE_API_CLIENTS_FAIL,
  PUT_API_CLIENTS_SECRET_REQUEST, PUT_API_CLIENTS_SECRET_SUCCESS, PUT_API_CLIENTS_SECRET_FAIL
} from 'src/store/actions/apiClientsActions';

const initialState = {
  fetching: false,
  list: [],
  restrictedClients: []
};

const updateInList = (list, item) => list.map((listItem) => (listItem.Id === item.Id ? item : listItem));

const apiClientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_API_CLIENTS_REQUEST:
    case POST_API_CLIENTS_REQUEST:
    case DELETE_API_CLIENTS_REQUEST:
    case PUT_API_CLIENTS_SECRET_REQUEST:
      return { ...state, fetching: true };
    case LOAD_API_CLIENTS_SUCCESS:
      return { ...state, list: action.payload, fetching: false };
    case POST_API_CLIENTS_SUCCESS:
      return { ...state, list: [...state.list, action.payload], fetching: false };
    case PUT_API_CLIENTS_SECRET_SUCCESS:
      return { ...state, list: updateInList(state.list, action.payload), fetching: false };
    case DELETE_API_CLIENTS_SUCCESS:
      return { ...state, list: state.list.filter((item) => item.Id !== action.payload.Id), fetching: false };
    case LOAD_RESTRICTED_CLIENTS_SUCCESS:
      return { ...state, restrictedClients: action.payload };
    case LOAD_API_CLIENTS_FAIL:
    case POST_API_CLIENTS_FAIL:
    case DELETE_API_CLIENTS_FAIL:
    case PUT_API_CLIENTS_SECRET_FAIL:
      return { ...state, fetching: false };
    default: return state;
  }
};

export default apiClientsReducer;
